import React, { useState } from "react";
import { getAuth, updateProfile } from "firebase/auth";
import { Input } from "@headlessui/react";
import { Button } from "../../../components/shadcn/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../../components/shadcn/ui/dialog";

interface ProfileImageUploaderProps {
  isOpen: boolean; // Controla se o modal está aberto
  onClose: () => void; // Função para fechar o modal
}

const ProfileImageUploader: React.FC<ProfileImageUploaderProps> = ({ isOpen, onClose }) => {
  const [photoURL, setPhotoURL] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleUpdatePhoto = async () => {
    setLoading(true);
    setError("");
    setSuccess(false);

    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      setError("No user is currently signed in.");
      setLoading(false);
      return;
    }

    try {
      await updateProfile(user, { photoURL });
      setSuccess(true);
      window.location.reload(); // Opcional: recarregar a página
    } catch (err: any) {
      setError(err.message || "An error occurred while updating the photo URL.");
    } finally {
      setLoading(false);
      onClose(); // Fechar o modal após sucesso ou erro
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md mx-auto p-6">
        <DialogHeader>
          <DialogTitle>Atualizar foto de perfil</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-4">
          <Input className = "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            type="text"
            placeholder="Adicione a url da foto"
            value={photoURL}
            onChange={(e) => setPhotoURL(e.target.value)}
          />

          {error && <p className="text-red-500 text-sm">{error}</p>}
          {success && <p className="text-green-500 text-sm">Foto de Perfil atualizada com sucesso!!</p>}

          <Button
            onClick={handleUpdatePhoto}
            disabled={loading || !photoURL}
            className="w-full"
          >
            {loading ? "Atualizando..." : "Atualizar Foto"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ProfileImageUploader;
